import { call, put, takeLatest } from "redux-saga/effects";
import {
  addRoleFailure,
  addRoleSuccess,
  deleteRoleFailure,
  deleteRoleSuccess,
  fetchAllRolesFailure,
  fetchAllRolesSuccess,
  fetchRoleFailure,
  fetchRolesFailure,
  fetchRolesSuccess,
  fetchRoleSuccess,
  updateRoleFailure,
  updateRoleSuccess,
} from "./roleAction";
import {
  addRoleEffect,
  deleteRoleEffect,
  editRoleEffect,
  listAllRoleEffect,
  listRoleEffect,
  ViewRoleEffect,
} from "./roleEffect";
import {
  ADD_ROLE_REQUEST,
  DELETE_ROLE_REQUEST,
  FETCH_ALL_LIST_ROLE_REQUEST,
  FETCH_LIST_ROLE_REQUEST,
  FETCH_ROLE_REQUEST,
  UPDATE_ROLE_REQUEST,
} from "./roleType";

function* fetchRolesSaga(action) {
  try {
    const Roles = yield call(listRoleEffect, action.payload);
    yield put(fetchRolesSuccess(Roles));
  } catch (error) {
    yield put(fetchRolesFailure(error.message));
  }
}

function* fetchAllRolesSaga(action) {
  try {
    const Roles = yield call(listAllRoleEffect, action.payload);
    yield put(fetchAllRolesSuccess(Roles));
  } catch (error) {
    yield put(fetchAllRolesFailure(error.message));
  }
}


function* fetchRoleSaga(action) {
  try {
    const Role = yield call(ViewRoleEffect, action.payload.RoleId);
    yield put(fetchRoleSuccess(Role));
  } catch (error) {
    yield put(fetchRoleFailure(error.message));
  }
}

function* addRoleSaga(action) {
  try {
    const newRole = yield call(addRoleEffect, action?.payload?.roleData);
    yield put(addRoleSuccess(newRole));
  } catch (error) {
    yield put(addRoleFailure(error.message));
  }
}

function* updateRoleSaga(action) {

  try {
    const updatedRole = yield call(
      editRoleEffect,
      action.payload?.roleId,
      action.payload?.roleData
    );
    yield put(updateRoleSuccess(updatedRole));
  } catch (error) {
    yield put(updateRoleFailure(error.message));
  }
}

function* deleteRoleSaga(action) {
  try {
    yield call(deleteRoleEffect, action.payload.roleId);
    yield put(deleteRoleSuccess(action.payload.RoleId));
  } catch (error) {
    yield put(deleteRoleFailure(error.message));
  }
}

export function* RoleSagas() {
  yield takeLatest(FETCH_LIST_ROLE_REQUEST, fetchRolesSaga);
  yield takeLatest(FETCH_ROLE_REQUEST, fetchRoleSaga);
  yield takeLatest(ADD_ROLE_REQUEST, addRoleSaga);
  yield takeLatest(UPDATE_ROLE_REQUEST, updateRoleSaga);
  yield takeLatest(DELETE_ROLE_REQUEST, deleteRoleSaga);
  yield takeLatest(FETCH_ALL_LIST_ROLE_REQUEST, fetchAllRolesSaga);
}